export const getFormattedPrice = (price,planId) => {return price ? (planId ? price: (price*100)) : 0}